const BOT_PATTERN
  = /bot|crawl|spider|slurp|lighthouse|headless|phantom|puppeteer|playwright|prerender|pingdom|gtmetrix|facebookexternalhit|embedly|quora|outbrain|pinterest|slackbot|vkshare|w3c_validator|baiduspider|yandex|duckduckbot|applebot|petalbot|semrush|ahrefs|mj12bot|dotbot/i;

/**
 * Heuristic client-side bot/crawler detection, used to skip loading expensive
 * client-only visuals (three.js) for automated agents and preview fetchers.
 *
 * @returns True when the current client looks like a bot, crawler, or headless agent
 */
export function isBot(): boolean {
  if ('undefined' === typeof navigator) {
    return false;
  }

  if (true === navigator.webdriver) {
    return true;
  }

  return BOT_PATTERN.test(navigator.userAgent);
}
